import { IAppState } from '../../redux';
import { ITotalAmount } from '../../redux/reducers';

export function selectTotalAmount(state: IAppState): ITotalAmount {
  return state.checkoutInfo.totalAmount;
}
